@if (isActionable) {
<mat-card>
  <mat-card-content>
    @if (showDuplicateButton()) {
    <div class="button-container">
      <button mat-flat-button color="primary" (click)="duplicate()" [disabled]="isSaving">{{ 'orders.duplicate' | transloco }}</button>
    </div>
    }
    @if (showUpdateBusinessReportButton()) {
    <div class="button-container">
      <button mat-flat-button color="primary" (click)="updateBusinessReport()" data-testid="order-actions-update">
        <mat-icon>replay</mat-icon> {{ 'orders.updateBusinessReport' | transloco }} </button>
    </div>
    }
    @if (showEditButton()) {
    <div class="button-container">
      <button mat-flat-button color="primary" (click)="edit()" data-testid="order-actions-edit">{{ 'common.labels.edit' | transloco }}</button>
    </div>
    }
    @if (showAmendmentButton()) {
    <div class="button-container">
      <button mat-flat-button color="primary" (click)="amend()" data-testid="order-actions-amend">{{ 'orders.amend' | transloco }}</button>
    </div>
    }
    @if (showRenewalButton()) {
    <div class="button-container">
      <button mat-flat-button color="primary" (click)="renew()" data-testid="order-actions-renew">{{ 'orders.renew' | transloco }}</button>
    </div>
    }
    @if (showReregistrationButton()) {
    <div class="button-container">
      <button mat-flat-button color="primary" (click)="reregister()" data-testid="order-actions-reregister">{{ 'orders.reregister' | transloco }}</button>
    </div>
    }
    @if (showDischargeButton()) {
    <div class="button-container">
      <button mat-flat-button color="warn" (click)="discharge()" data-testid="order-actions-discharge">{{ 'orders.totalDischarge' | transloco }}</button>
    </div>
    }
    @if ((linkableUboTreeNodes?.length ?? 0) > 0) {
    <div class="button-container">
      <button mat-flat-button color="primary" (click)="linkToHubReport()"
        data-testid="order-actions-link-hub-report">
        <mat-icon>link_2</mat-icon> {{ 'orders.linkToHubReportCount' | transloco: { count: linkableUboTreeNodes?.length } }} </button>
    </div>
    }
    @if (showUltimateBeneficialOwnershipReportButton()) {
    <div class="button-container">
      <button mat-flat-button color="primary" (click)="ultimateBeneficialOwnershipReport()"
        data-testid="order-actions-ubo">
        <mat-icon>account_child_invert</mat-icon> {{ 'orders.uboReport' | transloco }} </button>
    </div>
    }
    @if (showPEPsAndSanctionsButton()) {
    <div class="button-container">
      <button mat-flat-button color="primary" (click)="requestPEPsAndSanctins()" data-testid="order-actions-peps">
        <mat-icon>local_police</mat-icon> {{ 'orders.pepsAndSanctions' | transloco }} </button>
    </div>
    }
  </mat-card-content>
</mat-card>
}

@if (showAttestationActionsCard()) {
  <mat-card>
    <mat-card-content>
      @if (isValidForExternalErrorCorrection && !isExternalErrorCorrection()) {
        <div class="button-container">
          <button mat-flat-button color="primary" (click)="correctAttestationConfirmation()" data-testid="order-actions-correct-attestation"
          [class.spinner]="isSaving" [disabled]="isSaving">
            <mat-icon>restart_alt</mat-icon> {{ 'orders.returnToAttestor' | transloco }} </button>
        </div>
      }
      
      @if (showResendAttestationButton()) {
        <div class="button-container">
          <button mat-flat-button color="primary" (click)="resendAttestationInvitation(order.orderStatusTypeID)" data-testid="order-actions-correct-attestation"
          [class.spinner]="isSaving" [disabled]="isSaving">
            <mat-icon>outgoing_mail</mat-icon> {{ 'orders.reSendAttestationRequest' | transloco }} </button>
        </div>
      }

      @if (!isActionable && showCancelAttestationRequestButton()) {
        <div class="button-container">
          <button mat-flat-button color="warn" (click)="cancelAttestationRequest()" data-testid="order-actions-cancel-attestation-request">
            <mat-icon>cancel</mat-icon> {{ 'orders.cancelAttestationRequest' | transloco }} </button>
        </div>
      }
        
      @if (shouldShowAttestoryHistoryButton()) {
        <div class="button-container">
          <button mat-flat-button color="primary" (click)="openAttestoryHistoryDialog()" data-testid="order-actions-attestor-history">
            {{ 'orders.attestorHistory' | transloco }}
          </button>
        </div>
      }
    </mat-card-content>
  </mat-card>
}

@if (showResendDvsButton()) {
<mat-card>
  <mat-card-content>
    <div class="button-container">
      <button mat-flat-button color="primary" (click)="resendDvs()" data-testid="order-actions-resend-idv"
        [class.spinner]="isSaving" [disabled]="isSaving">
        <mat-icon>outgoing_mail</mat-icon>{{ 'orders.reSendDocumentVerification' | transloco }}</button>
    </div>
    <div class="button-container">
      <button mat-flat-button color="warn" (click)="cancelDocumentVerification()" data-testid="order-actions-cancel-identity-verification">
        <mat-icon>cancel</mat-icon> {{ 'orders.cancelDocumentVerification' | transloco }} </button>
    </div>
  </mat-card-content>
</mat-card>
}
